<div
  class="autocomplete-v2"
  [class.autocomplete-v2--with-icon]="iconName"
  [ngClass]="inputClass"
>
  <div
    role="combobox"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-owns]="listboxId"
    aria-haspopup="listbox"
    class="autocomplete-v2__combobox"
  >
    <vtmn-play-icon
      *ngIf="iconName"
      [name]="iconName"
      class="autocomplete-v2__combobox__icon"
    ></vtmn-play-icon>
    <input
      [id]="id"
      aria-autocomplete="list"
      [attr.aria-controls]="value"
      [attr.aria-activedescendant]="focusItemId"
      class="autocomplete-v2__combobox__input"
      [class.autocomplete-v2__combobox__input--has-value]="value !== null"
      autocomplete="off"
      [formControl]="input"
      [placeholder]="placeholder"
      (focus)="displayListbox()"
      (keydown)="onKeyDown($event)"
      data-test="input"
    />

    <button
      *ngIf="value"
      type="button"
      class="autocomplete-v2__combobox__clear-button"
      [type]="ctaButtonType.Button"
      [attr.aria-label]="clearButtonAriaLabel"
      (click)="clearInput()"
    >
      <vtmn-play-icon [name]="iconType?.Close"></vtmn-play-icon>
    </button>
  </div>

  <div
    *ngIf="this.hasContent || filteredItems?.length"
    class="autocomplete-v2__listbox"
    [id]="listboxId"
    [class.hidden]="!isExpanded"
    data-test="search-sports-result"
  >
    <ng-content></ng-content>

    <ul class="autocomplete-v2__listbox__list">
      <li
        #listItem
        *ngFor="let item of filteredItems; let index = index"
        [id]="getItemId(index)"
        (click)="selectItem(item)"
        class="autocomplete-v2__listbox__list__item"
        [class.autocomplete-v2__listbox__list__item--focus]="isFocus(index)"
        onKeyPress
        onKeyDown
        onKeyUp
      >
        {{ item.text }}
      </li>
    </ul>

    <ng-content select="[listbox-footer]"></ng-content>
  </div>
</div>
